// extracted by mini-css-extract-plugin
export default {"appContainer":"lrLHujPp","notFoundWrapper":"EeIu2cK0","notFoundDesc":"DDQ9ieyo","notFoundImg":"Lf1x18X4","btn":"t1Sz0DjA"};